import React from 'react'
import type { ShowToastOptions} from '@ztechapps/common.hook';
import { ToastContext } from '@ztechapps/common.hook'
import type { ToastComponent } from './component';
import { defaultComponent } from './component'

export type ToastProviderProps = {
  component?: ToastComponent
  children: React.ReactNode
}

const showToastDefaultOptions: ShowToastOptions = {
  type: 'success',
  title: 'Notification',
  message: 'Notification message...',
  show: false,
}

export const ToastProvider = ({ children, component, ...props }: ToastProviderProps) => {
  component = component ?? defaultComponent

  const [showToastOptions, setShowToastOptions] = React.useState<ShowToastOptions>(showToastDefaultOptions)

  //here is the provider for the toast actions
  const actions = new component.toaster.toastAction(showToastOptions, setShowToastOptions)

  const showToast = (options?: ShowToastOptions) => {
    actions.showToast(options)
  }
  const showError = (options?: ShowToastOptions) => {
    actions.showError(options)
  }

  const showSuccess = (options?: ShowToastOptions) => {
    actions.showSuccess(options)
  }

  const showInfo = (options?: ShowToastOptions) => {
    actions.showInfo(options)
  }
  const showWarning = (options?: ShowToastOptions) => {
    actions.showWarning(options)
  }

  const showNotification = (message: string) => {
    actions.showNotification(message)
  }

  return (
    <ToastContext.Provider value={{ ...props, showToast, showError, showSuccess, showInfo, showWarning, showNotification }}>
      <component.toaster.toaster showToastOptions={showToastOptions} setShowToastOptions={setShowToastOptions} />
      {children}
    </ToastContext.Provider>
  )
}
